<template>
  <v-menu v-model="options.show" :position-x="options.x" :position-y="options.y" absolute offset-y>
    <div class="border-wrap">
      <v-list>
        <v-list-item v-for="(item, index) in options.items" :key="index" @click="item.handler" style="min-height: 20px">
          <v-list-item-icon class="mt-1 mb-1" style="align-self: auto !important;">
            <v-icon small>{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content class="pt-1 pb-1">
            <v-list-item-title>{{ item.text }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </div>
  </v-menu>
</template>

<script>
export default {
  props: {
    options: {
      type: Object,
      required: true,
    },
  },
};
</script>
